module.exports = __webpack_public_path__ + "img/right2-mobile.e465a8dc.png";